import { z } from "zod"
import { type Scalar } from "@/graphql"

export type PaymentInstructionStatus = Scalar<"PaymentInstructionStatus">

export const PaymentInstructionStatus = {
    ACTIVE: "ACTIVE",
    FAILED: "FAILED",
    PROVISIONAL: "PROVISIONAL",
} as const satisfies Record<PaymentInstructionStatus, PaymentInstructionStatus>

export const PaymentInstructionStatusSchema = z.enum(PaymentInstructionStatus)
